import React from "react";
import Nav from "@/components/volotag/Nav";
import Hero from "@/components/volotag/Hero";
import InteractionMoment from "@/components/volotag/InteractionMoment";
import ProductCallout from "@/components/volotag/ProductCallout";
import Problem from "@/components/volotag/Problem";
import Solution from "@/components/volotag/Solution";
import HowItWorks from "@/components/volotag/HowItWorks";
import UseCases from "@/components/volotag/UseCases";
import Stories from "@/components/volotag/Stories";
import Showcase from "@/components/volotag/Showcase";
import WhyVoloTag from "@/components/volotag/WhyVoloTag";
import Waitlist from "@/components/volotag/Waitlist";
import SocialProof from "@/components/volotag/SocialProof";
import Founder from "@/components/volotag/Founder";
import FAQ from "@/components/volotag/FAQ";
import FinalCTA from "@/components/volotag/FinalCTA";
import Footer from "@/components/volotag/Footer";

export default function Landing() {
  return (
    <main className="relative bg-[#FAFAFA] text-zinc-900 min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <InteractionMoment />
      <ProductCallout />
      <Problem />
      <Solution />
      <HowItWorks />
      <Showcase />
      <Stories />
      <UseCases />
      <WhyVoloTag />
      <Waitlist />
      <SocialProof />
      <Founder />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
